<template>
  <b-modal title="Informações do Equipamento" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="m-2">
        <b-col cols="6">
          <b-form-group label="Cliente:" label-for="cliente" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="editing.cliente">
              <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
                >{{ cliente.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Nome:" label-for="nome" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="nome" v-model="editing.nome" />
          </b-form-group>

          <b-form-group label="Fabricante:" label-for="fab" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="fabricante" v-model="editing.fabricante" />
          </b-form-group>

          <b-form-group label="Peso:" label-for="peso" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="peso" v-model="editing.peso" />
          </b-form-group>

          <b-form-group label="Grupo:" label-for="grupo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="grupo" v-model="editing.grupo" />
          </b-form-group>

          <b-form-group label="Imagem:" label-for="imagem" label-cols-sm="3" label-align-sm="right">
            <b-form-file
              type="file"
              class="text-left mt-1"
              v-model="arquivo"
              placeholder="Solte o arquivo da imagem .jpg"
              drop-placeholder="Solte o arquivo da imagem .jpg"
              accept=".jpg"
            />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Código:" label-for="codigo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="codigo" v-model="editing.codigo" />
          </b-form-group>

          <b-form-group label="Dimensões:" label-for="dimensoes" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="dimensoes" v-model="editing.dimensoes" />
          </b-form-group>

          <b-form-group label="Carga:" label-for="carga" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="carga" v-model="editing.carga" />
          </b-form-group>

          <b-form-group label="Referência:" label-for="referencia" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="referencia" v-model="editing.referencia" />
          </b-form-group>

          <b-form-group label="Responsável:" label-for="responsavel" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="responsavel" v-model="editing.responsavel" />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- ::::::::::::::: Observações fora do escopo duplo ::::::::::::::: -->
      <b-row class="mr-2 ml-2">
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="editing.observacao" rows="3" max-rows="6"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-input-group class="clone-input">
        <b-input-group-prepend is-text>
          <b-icon icon="search" @click="clonar()"></b-icon>
        </b-input-group-prepend>
        <b-form-input type="number" placeholder="Clonar Sgcq" v-model="clone" />
      </b-input-group>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { storeToRefs } from "pinia";
import Equipamento from "@/models/Equipamento";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";

export default {
  name: "ModalDeEdicaoDeEquipamento",

  data() {
    return {
      show: false,
      editing: new Equipamento(0, "", "", "", "", "", "", "", "", "", "", ""),
      files: new Files(this.$http),
      arquivo: null,
      selecionado: null,
      clone: "",
    };
  },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente;
    },
  },

  methods: {
    salvar() {
      if (this.editing.sgcq != 0) {
        this.equipamentoStore.ALTERAR_EQUIPAMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Equipamento salvo no SGCQ com sucesso!", "Excelente!", "success"));
          if (this.arquivo != null) {
            const filename = this.editing.sgcq + ".jpg";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadEquipamento(filename, formData);
          }
          this.$emit("showAtualizado", this.editing);
        });
      } else {
        this.equipamentoStore
          .CADASTRAR_EQUIPAMENTO(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Equipamento salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    clonar() {
      let clonado = this.getBySgcq(this.clone);
      if (clonado[0]) {
        this.editing.nome = clonado[0].nome;
        this.editing.codigo = clonado[0].codigo;
        this.editing.fabricante = clonado[0].fabricante;
        this.editing.dimensoes = clonado[0].dimensoes;
        this.editing.peso = clonado[0].peso;
        this.editing.carga = clonado[0].carga;
        this.editing.observacao = clonado[0].observacao;
        this.editing.grupo = clonado[0].grupo;
        this.editing.referencia = clonado[0].referencia;
      }
    },

    call(equipamento) {
      this.show = !this.show;
      this.editing.update(equipamento);
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const clienteStore = useClienteStore();
    const { getFilterClientes } = storeToRefs(clienteStore);

    return {
      store,
      equipamentoStore,
      clienteStore,
      getFilterClientes,
      getBySgcq,
    };
  },
};
</script>

<style lang="scss" scoped>
.clone-input {
  width: 12rem;
}
</style>
